import { queryOptions } from '@tanstack/react-query';

import { defaultApiParamStr } from '@/_shared';

import { getPickTicketsAllQuery, getPickTicketsQuery } from './shared';

export const getPickTicketsQueryOptions = (id: string) => queryOptions(getPickTicketsQuery(id));
export const getPickTicketsAllQueryOptions = () =>
  queryOptions(getPickTicketsAllQuery(`${defaultApiParamStr}&filter[status]=In Process,On Hold`));
